import type React from 'react';

import { DeleteVariantIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import type { WithDataTestid } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import st from './DeletePersonCardsConfirmation.module.sass';

interface DeletePersonCardsConfirmationProps extends WithDataTestid {
  externalIds: string[];
  onConfirm: VoidFunction;
  onReject: VoidFunction;
}

function DeletePersonCardsConfirmation({
  externalIds,
  onConfirm,
  onReject,
  'data-testid': dataTestId = undefined,
}: DeletePersonCardsConfirmationProps): React.JSX.Element {
  const { t } = useTranslation();
  const count = externalIds.length;
  return (
    <div
      className={st.DeletePersonCardsConfirmation}
      data-testid={dataTestId}
    >
      <div className={st.IconAndText}>
        <DeleteVariantIcon className={st.Icon} />
        <div className={st.Body}>
          <h5 className={st.Title}>{t('features:deletePerson.confirmation.title', { count }) as unknown as string}</h5>
          <div className={st.Description}>
            {t('features:deletePerson.confirmation.description', {
              count,
              id: externalIds,
            })}
          </div>
        </div>
      </div>
      <div className={st.Actions}>
        <Control.Button
          kind="secondary"
          onClick={onReject}
          variant="outlined"
        >
          {t('features:deletePerson.confirmation.onReject')}
        </Control.Button>
        <Control.Button
          kind="negative"
          onClick={onConfirm}
          variant="filled"
        >
          {t('features:deletePerson.confirmation.onConfirm')}
        </Control.Button>
      </div>
    </div>
  );
}

export { DeletePersonCardsConfirmation };
